export default __webpack_public_path__ + "static/media/details.8e1e34ba.svg";